import { css } from '@emotion/css';
import { createTheme, type MantineTheme, Select } from '@mantine/core';
import type { PartialDeep } from 'type-fest';

const selectStyles = {
  input: (theme: MantineTheme) => css`
    &:focus {
      border-color: ${theme.colors.purple[5]} !important;
    }
  `,
  dropdown: (theme: MantineTheme) => css`
		&:hover {
			background-color: ${theme.colors.purple[1]};
	`,
};

export const ThemedMantineSelect: PartialDeep<MantineTheme> = createTheme({
  components: {
    Select: Select.extend({
      styles: (theme, params) => {
        if (params.variant === 'unstyled') {
          if (params.disabled) {
            return {
              input: {
                backgroundColor: 'transparent',
              },
            };
          }
          return {};
        }

        return {
          input: {
            paddingVertical: theme.spacing.space2,
            borderRadius: 8,
            borderColor: theme.colors.gray[3],
            backgroundColor: theme.colors.gray[0],
            color: theme.colors.gray[7],
          },
          section: {
            color: theme.colors.gray[7],
          },
          dropdown: {
            borderRadius: 8,
            borderColor: theme.colors.gray[2],
            borderWidth: 1,
          },
          option: {
            color: theme.colors.gray[10],
          },
        };
      },
      classNames: (theme, params) => {
        if (params.variant === 'unstyled') {
          return {};
        }

        return {
          input: selectStyles.input(theme),
          option: selectStyles.dropdown(theme),
        };
      },
    }),
  },
});
